<template>
  <div>
    <Modal :modalId="modalId" size="modal-lg">
      <ModalHeader
        :title="$t('xPendingPlanChangeInProgress')"
        icon="far fa-exclamation-triangle"
        :style="{ padding: '10px 10px 10px 10px' }"
      >
        <div class="cols-auto">
          <button type="button" class="btn btn-icon-button btn-icon-button--gray" @click="handleCloseClick()">
            <i class="fas fa-times" />
          </button>
        </div>
      </ModalHeader>
      <ModalBody>
        <div class="row">
          <div class="col">
            {{ $t('xPendingPlanChangeExplanationText') }}
          </div>
        </div>
        <div class="row mt-4 mb-3">
          <div class="col">
            {{ $t('xPendingPlanChangeAreYouSure') }}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button type="button" @click="handleCloseClick()" class="btn btn-secondary mr-2">
          {{ $t('xNoCancelButtonText') }}
        </button>
        <button
          type="button"
          @click="continueToOverwritePendingChanges()"
          class="btn btn-primary"
          :disabled="billingMaintenanceFeatureFlagEnabled(currentAppConfig)"
        >
          {{ $t('xYesContinueButtonText') }}
        </button>
      </ModalFooter>
    </Modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
/**
 * The PendingPlanChangeModal shows on the SubscriptionSettings details page, dashboard cards, and enrollment flows when there is a pending change
 * with the user's subscription and they try to update/upgrade their subscription. This modal warns them that pending changes will be overwritten.
 */
export default {
  props: ['modalId'],
  emits: ['onYesContinueClick'],
  methods: {
    continueToOverwritePendingChanges() {
      this.$appInsights.trackEvent({
        name: 'click-continue-to-overwrite-pending-subscription-changes-modal',
        properties: {}
      })
      this.closePendingPlanChangeModal()
      this.$emit('onYesContinueClick')
    },

    handleCloseClick() {
      this.$appInsights.trackEvent({
        name: 'click-close-pending-subscription-changes-modal',
        properties: {}
      })
      this.closePendingPlanChangeModal()
    },

    closePendingPlanChangeModal() {
      this.closeModal(this.modalId)
    }
  },
  computed: {
    ...mapState({
      currentAppConfig: state => state.application.currentAppConfig
    })
  }
}
</script>
